import axios from "axios";
import { store } from "../Store/store";
import logUserOut from "../Auth/logUserOut";
import { UNAUTHORIZED_USER } from "../Auth/statusCodes";
import { config, localeMap } from "../consts/constant";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || config.url.API_URL,
  withCredentials: true,
  headers: {
    platformType: "patient",
  },
});

axiosInstance.interceptors.request.use((request) => {
  request.headers["Content-Type"] = "application/json";
  const lang = store.getState().languageChange.language;
  request.headers["accept-language"] = localeMap(lang);
  return request;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (originalRequest?.skipAuthRefresh) {
      logUserOut();
      return Promise.reject(error);
    }
    if (
      error.response?.status === UNAUTHORIZED_USER &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        await axiosInstance.post(
          "user/auth/token/refresh",
          {},
          { skipAuthRefresh: true },
        );

        return axiosInstance(originalRequest);
      } catch (refreshError) {
        logUserOut();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
